import Mixin from 'mixmatch';

export default class History extends Mixin {
  async history(id: string, params = {}) {
    const options = {
      method: 'GET',
      // @ts-ignore
      path: this.memberAction(id, 'history'),
      qs: params,
    };
    // @ts-ignore
    const body = await this.call(options);
    // @ts-ignore
    return JSON.parse(body)[this.resourcesName];
  }
}
